module.exports = __webpack_public_path__ + "static/media/css3.3707da3c.svg";